import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  border: `1px solid ${spaceCadet[300]}`,
  padding: 8,
  borderRadius: 4,
  maxHeight: 600,
  '& > .MuiTypography-subtitle1': {
    color: spaceCadet[400],
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '24px',
    fontSize: 14,
  },
  '& > .MuiBox-root': {
    display: 'flex',
    flexDirection: 'column',
    padding: 8,
    gap: 8,
    border: `1px solid ${spaceCadet[100]}`,
    borderRadius: 6,
    '& .MuiTypography-subtitle2': {
      fontSize: 14,
      fontWeight: 600,
    },
    '& > .MuiBox-root.header': {
      display: 'flex',
      gap: 8,
      alignSelf: 'flex-start',
      alignItems: 'center',
    },
    '& > .MuiBox-root.content': {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      '& > .MuiTypography-body2': {
        fontSize: 14,
      },
    },
  },
});

export default StyledBox;
